import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import './theme/css/root.css';
import './theme/css/typography.css';
import './theme/css/layout.css';
import './theme/css/distance.css';
import './theme/css/utils.css';

import {
  Font,
} from '@react-pdf/renderer';

import RobotoRegular from './fonts/Roboto-Regular.ttf';
import RobotoLight from './fonts/Roboto-Light.ttf';
import RobotoBold from './fonts/Roboto-Bold.ttf';

Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: RobotoRegular,
    },
    {
      src: RobotoBold,
      fontWeight: 'bold',
    },
    {
      src: RobotoLight,
      fontWeight: 'normal',
    },
  ],
});

ReactDOM.render(
  <App />,
  document.getElementById("root")
);
